import { supabase } from "./core.js";

export async function fetchCompanySetting(key: string): Promise<string | null> {
  const { data, error } = await supabase
    .from("company_settings")
    .select("value")
    .eq("key", key)
    .single();
  if (error) {
    if (error.code === "PGRST116") return null;
    throw error;
  }
  return data?.value ?? null;
}

export async function upsertCompanySetting(key: string, value: string): Promise<void> {
  const { error } = await supabase
    .from("company_settings")
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: "key" });
  if (error) throw error;
}
